import React from 'react';
import { pathOr } from 'ramda';
import { formatDateDisplayUTC } from '@fortress-technology-solutions/fortress-component-library/utils/index';
import Styled from 'styled-components';

import { Field, FormSection } from 'redux-form';
import { FormattedNumber } from 'react-intl';

import {
  renderCurrencyField,
  renderDateField,
} from '../../../utils/redux-form-helper';
import {
  getLatestActiveScheduleRow,
  getHudGrossRentScheduleRows,
  getHudUaSnapshotFee,
  getHudGrossRentSnapshotFee,
  getRowScheduleFee,
  isValidDateBuilder,
} from './utils';

const StyledCurrencyFieldColumn = Styled('td')`
  min-width: 125px;
`;

const FloorplanDetail = ({ floorPlan }: Object) => {
  const startOfFloorPlan = formatDateDisplayUTC(floorPlan.createdAt);

  const allowances =
    pathOr([], ['fpua'], floorPlan).length > 0
      ? pathOr([], ['fpua'], floorPlan)
      : pathOr([], ['allowances'], floorPlan);
  const hudGrossRents = getHudGrossRentScheduleRows(floorPlan);

  const currentAllowanceRow =
    getLatestActiveScheduleRow(allowances, getHudUaSnapshotFee(floorPlan)) ||
    {};
  const latestAllowanceStartDate = pathOr(
    startOfFloorPlan,
    ['startDate'],
    currentAllowanceRow,
  );
  const allowanceFee = getRowScheduleFee(currentAllowanceRow);
  const currentAllowanceAmount = Number.isFinite(allowanceFee)
    ? allowanceFee
    : 0;

  const currentHudGrossRentRow =
    getLatestActiveScheduleRow(
      hudGrossRents,
      getHudGrossRentSnapshotFee(floorPlan),
    ) || {};
  const latestHudGrossRentStartDate = pathOr(
    startOfFloorPlan,
    ['startDate'],
    currentHudGrossRentRow,
  );
  const currentHudGrossRentAmount = pathOr(
    0,
    ['feeAmount'],
    currentHudGrossRentRow,
  );

  const isValidRentDate = isValidDateBuilder(latestHudGrossRentStartDate);
  const isValidAllowanceDate = isValidDateBuilder(latestAllowanceStartDate);

  return (
    <FormSection name={floorPlan.id}>
      <tr key={floorPlan.id}>
        <td>{floorPlan.internalName}</td>
        <td>{floorPlan.marketingName}</td>
        <td>
          <FormattedNumber
            value={currentHudGrossRentAmount}
            style="currency" // eslint-disable-line react/style-prop-object
            currency="USD"
          />
        </td>
        <StyledCurrencyFieldColumn>
          <Field
            name={'newHudGrossRent'}
            component={renderCurrencyField}
            messageAsTooltip
            min="0"
            max="9999.99"
            step=".01"
            precision={2}
          />
        </StyledCurrencyFieldColumn>
        <td>
          <Field
            name={'newHudGrossRentStartDate'}
            isValidDate={isValidRentDate}
            component={renderDateField}
            messageAsTooltip
            dateFormat="MM/DD/YYYY"
            bsSize="md"
            utc
          />
        </td>
        <td>
          <FormattedNumber
            value={currentAllowanceAmount}
            style="currency" // eslint-disable-line react/style-prop-object
            currency="USD"
          />
        </td>
        <StyledCurrencyFieldColumn>
          <Field
            name={'newHudUa'}
            component={renderCurrencyField}
            messageAsTooltip
            min="0"
            max="9999.99"
            step=".01"
            precision={2}
          />
        </StyledCurrencyFieldColumn>
        <td>
          <Field
            name={'newHudUaStartDate'}
            isValidDate={isValidAllowanceDate}
            component={renderDateField}
            messageAsTooltip
            placement="left"
            dateFormat="MM/DD/YYYY"
            bsSize="md"
            className="right-calendar"
            utc
          />
        </td>
      </tr>
    </FormSection>
  );
};

export default FloorplanDetail;
